

// Media file definition
class MediaVM {
  uuid: string;
  name: string;
  file_name: string;
  mime_type: string;
  size: number;
  updated_at: string;
  type: string;
  extension: string;

  constructor(data?: Partial<MediaVM>) {
    this.uuid = data?.uuid || ''
    this.name = data?.name || ''
    this.file_name = data?.file_name || ''
    this.mime_type = data?.mime_type || ''
    this.size = data?.size || 0
    this.updated_at = data?.updated_at || ''
    this.type = data?.type || ''
    this.extension = data?.extension || ''
  }
}

// File definition
class FileVM {
  id: number;
  uuid: string;
  name: string;
  is_file: boolean;
  parent_id: string;
  created_at: string;
  updated_at: string;
  url: string;
  media: MediaVM[];

  constructor(data?: Partial<FileVM>) {
    this.id = data?.id || 0
    this.uuid = data?.uuid || ''
    this.name = data?.name || ''
    this.is_file = data?.is_file || false
    this.parent_id = data?.parent_id || ''
    this.created_at = data?.created_at || ''
    this.updated_at = data?.updated_at || ''
    this.url = data?.url || ''
    this.media = data?.media ? data.media.map(m => (m)) : []
  }
}
export {FileVM, MediaVM}
